import React from 'react'
import { useSelector } from 'react-redux'

import { calculateImpressionsFromBudget } from '../../../../UploadAdCreative/ImpressionsBudgetSection/helpers'

import { rightSelector } from '../../../../../../modules/selectors/rights'

import { BUDGET } from '../../../../../Tiktok/CampaignForms/CampaignTikTokEdit/fields'

const TikTokLineItemImpressionsBudgetPreview = ({ lineItem }) => {
  const { bid_cap: rightBidCap } = useSelector(rightSelector)

  const impressions = calculateImpressionsFromBudget({
    budget: lineItem?.[BUDGET],
    rightBidCap
  })

  return <p>{impressions}</p>
}

export default TikTokLineItemImpressionsBudgetPreview
